import styled from 'styled-components';

export default styled.div`
  position: relative;
  width: 200px;
  height: 10px;
  cursor: pointer;
  margin-bottom: 5px;
`;
